import React from 'react';
import { Link } from 'react-router-dom';

const FormasDePagoPage = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-3xl">💝</span>
            <span className="text-2xl font-script font-bold text-accent-600">
              SobreDigital
            </span>
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-gradient-to-r from-accent-500 to-primary-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-display font-bold mb-4">
            Formas de Pago
          </h1>
          <p className="text-xl text-white/90">
            Elegí la opción que más te convenga
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Payment Methods */}
        <div className="space-y-8">
          
          {/* MercadoPago */}
          <div className="card p-8">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-20 h-20 bg-blue-100 rounded-xl flex items-center justify-center">
                <span className="text-4xl">💳</span>
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-display font-bold text-neutral-900 mb-3">
                  MercadoPago
                </h2>
                <p className="text-neutral-700 mb-4">
                  La forma más rápida y segura de pagar. Aceptamos todas las tarjetas de crédito y débito.
                </p>
                
                <div className="space-y-3 mb-4">
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Tarjetas de crédito y débito (Visa, Mastercard, Amex)</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Pago en cuotas disponible</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Acreditación inmediata (24-48hs)</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">100% seguro y certificado</span>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <p className="text-sm text-blue-900">
                    <strong>Comisión:</strong> MercadoPago puede cobrar una pequeña comisión según el método de pago elegido. 
                    El monto exacto se muestra antes de confirmar.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Transferencia */}
          <div className="card p-8">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-20 h-20 bg-green-100 rounded-xl flex items-center justify-center">
                <span className="text-4xl">🏦</span>
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-display font-bold text-neutral-900 mb-3">
                  Transferencia Bancaria
                </h2>
                <p className="text-neutral-700 mb-4">
                  Transferí directamente desde tu home banking. Sin comisiones adicionales.
                </p>
                
                <div className="space-y-3 mb-4">
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Sin comisiones extras</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Acreditación inmediata</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Desde cualquier banco</span>
                  </div>
                </div>

                <div className="bg-neutral-100 rounded-lg p-4 space-y-2">
                  <p className="font-semibold text-neutral-900">Pasos:</p>
                  <ol className="list-decimal list-inside text-sm text-neutral-700 space-y-1">
                    <li>Al elegir "Transferencia" verás los datos bancarios de los novios</li>
                    <li>Copiá el CBU o Alias</li>
                    <li>Ingresá a tu home banking</li>
                    <li>Realizá la transferencia por el monto del regalo</li>
                    <li>¡Listo! Los novios lo verán en su panel</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Depósito */}
          <div className="card p-8">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-20 h-20 bg-yellow-100 rounded-xl flex items-center justify-center">
                <span className="text-4xl">💵</span>
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-display font-bold text-neutral-900 mb-3">
                  Depósito Bancario
                </h2>
                <p className="text-neutral-700 mb-4">
                  Depositá en efectivo en cualquier sucursal o cajero automático.
                </p>
                
                <div className="space-y-3 mb-4">
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">En efectivo</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">En cualquier sucursal bancaria</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">También en cajeros automáticos</span>
                  </div>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                  <p className="text-sm text-yellow-900">
                    <strong>Importante:</strong> Asegurate de guardar el comprobante del depósito. 
                    El banco puede cobrarte una pequeña comisión por el servicio.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* PayPal */}
          <div className="card p-8">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-20 h-20 bg-purple-100 rounded-xl flex items-center justify-center">
                <span className="text-4xl">🌐</span>
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-display font-bold text-neutral-900 mb-3">
                  PayPal
                </h2>
                <p className="text-neutral-700 mb-4">
                  Ideal para regalos desde el exterior. Acepta tarjetas internacionales y saldos en PayPal.
                </p>
                
                <div className="space-y-3 mb-4">
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Acepta tarjetas de todo el mundo</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Conversión automática de moneda</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-accent-600 mt-1">✓</span>
                    <span className="text-neutral-700">Protección al comprador incluida</span>
                  </div>
                </div>

                <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                  <p className="text-sm text-purple-900">
                    <strong>Perfecto para invitados internacionales:</strong> Si estás fuera de Argentina, 
                    PayPal es tu mejor opción. El tipo de cambio se calcula automáticamente.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Security Section */}
        <div className="mt-12 bg-gradient-to-r from-accent-50 to-primary-50 rounded-2xl p-8">
          <div className="text-center mb-6">
            <div className="text-5xl mb-4">🔒</div>
            <h2 className="text-3xl font-display font-bold text-neutral-900 mb-3">
              Tu Seguridad es Nuestra Prioridad
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-3xl mb-2">✓</div>
              <h4 className="font-semibold text-neutral-900 mb-2">Encriptación SSL</h4>
              <p className="text-sm text-neutral-700">Toda la información viaja encriptada</p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🛡️</div>
              <h4 className="font-semibold text-neutral-900 mb-2">Plataformas Certificadas</h4>
              <p className="text-sm text-neutral-700">MercadoPago y PayPal son líderes en seguridad</p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🔐</div>
              <h4 className="font-semibold text-neutral-900 mb-2">Sin Guardar Datos</h4>
              <p className="text-sm text-neutral-700">No almacenamos información de tarjetas</p>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="mt-12">
          <h2 className="text-2xl font-display font-bold text-neutral-900 mb-6">
            Preguntas sobre Pagos
          </h2>
          
          <div className="space-y-4">
            <div className="bg-white border border-neutral-200 rounded-lg p-6">
              <h4 className="font-semibold text-neutral-900 mb-2">
                ¿Puedo cambiar el método de pago después?
              </h4>
              <p className="text-neutral-700">
                No. Una vez confirmado el pago, no se puede modificar. Asegurate de elegir bien tu método de pago.
              </p>
            </div>

            <div className="bg-white border border-neutral-200 rounded-lg p-6">
              <h4 className="font-semibold text-neutral-900 mb-2">
                ¿Los novios ven mi información de pago?
              </h4>
              <p className="text-neutral-700">
                No. Los novios solo ven tu nombre, email, mensaje y el monto del regalo. 
                Nunca ven datos de tarjetas o información bancaria.
              </p>
            </div>

            <div className="bg-white border border-neutral-200 rounded-lg p-6">
              <h4 className="font-semibold text-neutral-900 mb-2">
                ¿Puedo pedir factura?
              </h4>
              <p className="text-neutral-700">
                Los comprobantes de MercadoPago y PayPal sirven como constancia del pago. 
                Para facturas específicas, contactá directamente con los novios.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 bg-gradient-to-r from-accent-500 to-primary-500 rounded-2xl p-8 text-center text-white">
          <h2 className="text-3xl font-display font-bold mb-4">
            ¿Listo para hacer tu regalo?
          </h2>
          <p className="text-xl mb-6 text-white/90">
            Elegí tu método de pago preferido
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/como-regalar" className="bg-white text-accent-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gold-100 transition-all inline-block">
              Ver Cómo Regalar
            </Link>
            <Link to="/" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-accent-600 transition-all inline-block">
              Buscar Lista
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-neutral-900 text-white py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-neutral-400 hover:text-white transition-colors">
            ← Volver al inicio
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default FormasDePagoPage;
